// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"61044335","422":"8017f441","451":"a1d971d8","558":"43051dad","654":"593f1bfb","671":"ff9b275a","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};